import { defineAsyncComponent } from "vue";
import { getI18n } from "@editor/ui-utils";
const de = {
  reusableTextApi: {
    created: "Wiederverwendbares Textfeld erstellt",
    updated: "Wiederverwendbares Textfeld aktualisiert",
    notFound: "Wiederverwendbares Textfeld nicht gefunden",
    requiredFields: "Sie können den Wiederverwendbares Textfeld nicht speichern, da obligatorische Informationen fehlen"
  },
  reusableTextList: {
    newButton: "Neue Textbox",
    name: "Nach Name oder ID des Textfelds suchen",
    deleteReusableText: "Löschen",
    duplicate: "Duplizieren",
    dpAny: "Alle",
    brand: "Marke",
    loading: "Lade Wiederverwendbares Textfeld",
    headerLabel: "Name der Textbox",
    headerTextContent: "Inhalt des Textsfelds",
    headerCreatedAt: "Erstellt am",
    headerChangedAt: "Geändert am",
    counter: "Zähler",
    dpEdit: "Bearbeiten",
    dpView: "Anzeigen",
    messageDeleted: "Wiederverwendbare Textbox gelöscht",
    errorOnDeleting: "Fehler beim Löschen",
    createReusableText: "Wiederverwendbares Textfeld erstellen"
  },
  reusableText: {
    reusableTextLabel: "Textbox",
    backButton: "Zurück zur Wiederverwendbares Textfeld-Liste",
    newReusableText: "Neue Textbox",
    messageDeleteReusableText: "Wiederverwendbares Textfeld löschen",
    messageDeleteReusableTextTitle: "Bist du sicher, dass du diese Textbox löschen möchtest? Sie wird überall gelöscht, wo sie derzeit verbaut ist.",
    deleteReusableText: "Löschen",
    placeholder: "Textbox auswählen",
    messageDeleted: "Wiederverwendbare Textbox gelöscht",
    errorOnDeleting: "Es gab einen Fehler beim Löschen des ReusableTexts",
    errorFailedLoadedReusableTextWithId: "Es gab einen Fehler beim Abrufen des ReusableTexts",
    handledInLegacySystem: "Dieser Wiederverwendbares Textfeld wird in {source} behandelt, Sie können ihn nicht auf Vibe bearbeiten"
  },
  reusableTextEdit: {
    label: "Name der wiederverwendbaren Textbox",
    counter: "Zähler",
    backButton: "Zurück zur Wiederverwendbares Textfeld-Liste",
    editReusableText: "TEXTBOX BEARBEITEN",
    messageSaved: "Neue Textbox gespeichert",
    messageUpdated: "Änderungen gespeichert"
  }
};
const en = {
  reusableTextApi: {
    created: "ReusableText created",
    updated: "ReusableText updated",
    notFound: "ReusableText not found",
    requiredFields: "You can't save the ReusableText because mandatory information is missing"
  },
  reusableTextList: {
    newButton: "New Textbox",
    name: "Search by Text box title or ID",
    deleteReusableText: "Delete",
    duplicate: "Duplicate",
    dpAny: "All",
    brand: "Brand",
    loading: "Loading ReusableText",
    headerLabel: "Textbox name",
    headerTextContent: "Text box content",
    headerCreatedAt: "Created at",
    headerChangedAt: "Changed at",
    counter: "Counter",
    dpEdit: "Edit",
    dpView: "View",
    messageDeleted: "Message deleted",
    errorOnDeleting: "Error on deleting",
    createReusableText: "Create ReusableText"
  },
  reusableText: {
    reusableTextLabel: "Reusable textbox",
    backButton: "Back to ReusableText list",
    newReusableText: "New Textbox",
    messageDeleteReusableText: "Delete ReusableText",
    messageDeleteReusableTextTitle: "Are you sure you want to delete this text box? It will be deleted wherever it is currently used.",
    deleteReusableText: "Delete",
    placeholder: "Select textbox",
    messageDeleted: "Reusable textbox deleted",
    errorOnDeleting: "There was an error deleting the ReusableText ",
    errorFailedLoadedReusableTextWithId: "There was an error getting the ReusableText",
    handledInLegacySystem: "This ReusableText is being handled in {source}, you can't edit it on Vibe"
  },
  reusableTextEdit: {
    label: "Name of the reusable textbox",
    counter: "Counter",
    backButton: "Back to ReusableText list",
    editReusableText: "EDIT TEXTBOX",
    messageSaved: "New textbox saved",
    messageUpdated: "Changes saved"
  }
};
const messages = { en, de };
const routes = [
  {
    path: "/reusable-text",
    children: [
      {
        path: "",
        name: "reusable_text_list",
        component: () => import("./reusable-text-list.view-B-GuYTaV.js"),
        meta: { requiredRight: "navigate_list_reusable_text" }
      },
      {
        path: "new",
        name: "reusable_text_new",
        component: () => import("./reusable-text-edit.view-BHCXCDO6.js"),
        props: () => ({
          title: getI18n().t("reusableText.newReusableText"),
          backRoute: "/reusable-text"
        }),
        meta: { requiredRight: ["navigate_reusable_text"] }
      },
      {
        path: ":id",
        name: "reusable_text_detail",
        component: () => import("./reusable-text-edit.view-BHCXCDO6.js"),
        props: (route) => ({
          title: getI18n().t("reusableTextEdit.editReusableText"),
          id: route.params.id,
          backRoute: "/reusable-text"
        }),
        meta: { requiredRight: ["navigate_reusable_text"] }
      }
    ]
  }
];
const ReusableTextContentBlock = defineAsyncComponent(() => import("./reusable-text-content-block-CjMao9Iy.js"));
const reusableTextModule = {
  messages,
  routes,
  contentBlocks: [
    {
      type: "REUSABLE_TEXT",
      label: "reusableText.reusableTextLabel",
      icon: "type",
      component: ReusableTextContentBlock,
      defaultValue: { type: "REUSABLE_TEXT" }
    }
  ]
};
export {
  ReusableTextContentBlock,
  reusableTextModule
};
//# sourceMappingURL=index.es.js.map
